import React from "react";
import SparrowEmbed from "./SparrowEmbed";

interface SentPageProps {
  childName: string;
  gender: string;
}

/**
 * Final confirmation page shown after successful card submission
 * - Thanks the user and informs them that their card has been sent
 * - Includes personalized messaging with the child's name and appropriate pronouns
 * - Contains embedded survey for user feedback
 */
const SentPage: React.FC<SentPageProps> = ({ childName, gender }) => {
  const indirectObjectPronoun = gender.toLowerCase() === "female" ? "her" : "him";

  return (
    <div className="sent-page">
      <div className="sak-engagement-flow__wrapper">
        <div className="sak-engagement-flow__header">
          <h1>
            Sending God’s love
            <br />
            through you
          </h1>
        </div>

        <div className="sak-engagement-flow__body">
          <p>
            Thank you for encouraging {childName} by taking some time to create this card and making{" "}
            {indirectObjectPronoun} feel seen and loved. You truly are sharing the love of Jesus!
          </p>
        </div>

        <div className="sak-engagement-flow__body">
          <p>
            Your photo and response will be placed on a special card for {childName}. Watch for a
            response — something special is on its way!
          </p>
        </div>

        <SparrowEmbed />
      </div>
    </div>
  );
};

export default SentPage;
